import React from "react";
import Header from "../../../Home/Header";
import Footer from "../../../Home/Footer";
import PolkadotHero from "./PolkadotHero";
import WhyChPolkadot from "./WhyChPolkadot";
import ParachainDev from "./ParachainDev";
import BenefitsOFCardano from "../Cardano/BenefitsOFCardano";

function Polkadot() {
  return (
    <div>
      <Header />
      <PolkadotHero />
      <WhyChPolkadot />
      <ParachainDev />
      <BenefitsOFCardano />
      <Footer />
    </div>
  );
}

export default Polkadot;
